"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePrinciple = exports.amortize = void 0;
var Calculator_1 = __importDefault(require("./Calculator"));
var Loan_1 = __importDefault(require("./models/Loan"));
function amortize(amount, downPayment, interest, years, paymentsPerYear) {
    var loan = new Loan_1.default(amount, downPayment, interest, years, paymentsPerYear);
    loan.calculate();
    return loan;
}
exports.default = amortize;
exports.amortize = amortize;
function calculatePrinciple(monthlyPayment, interest, years, paymentsPerYear) {
    return Calculator_1.default.calculatePrinciple(monthlyPayment, interest, years, paymentsPerYear);
}
exports.calculatePrinciple = calculatePrinciple;
